<template lang="pug">
  div(class="container")
    div(v-if="slider").pb-4
      v-row().px-4
        v-flex(xs12 md12 lg12)
          v-slider(label="Time Scale:" v-model="timeIndex" :tick-labels="timescale" :max="years-1" step="1" ticks="always" tick-size="6" @click="rescale")
     
    bar-chart(v-if="loaded" :chartdata="chartdata" :options="options" :componentkey="componentkey")
    
    div(class="text-center" v-if="!loaded").mt-12
      v-progress-circular(indeterminate class="mb-2" :size="50" :width="5" color="primary")
</template>

<script>
import BarChart from "../BarChart";
//import moment from "moment";

export default {
  name: "ParkingTransactionsByRegion",
  props: ["slider", "length", "startyear"],
  components: { BarChart },
  data: () => ({
    loaded: false,
    chartdata: Object,
    options: Object,
    years: 5,
    timeIndex: Number,
    componentkey: 0,
    chartType: ["Bar", "Line"]
  }),
  async mounted() {
    this.timeIndex = this.years - 1;
    this.bindChart();
  },
  methods: {
    bindChart() {
      this.getData()
        //.then(this.sortData)
        .then(this.plotData);
    },

    getData() {
      const yeardate = `${this.timescale[this.timeIndex]}-01-01`;
      console.log(yeardate)
      return new Promise(resolve => {
        fetch(
          `https://datahub-v2.arlingtonva.us/api/ParkingMeter/ParkingTransactionsByRegion?$filter=yeardate eq ${yeardate}&$top=${this.length}&$orderby=yeardate desc,revenue desc`
        ).then(response => {
          resolve(response.json());
        });
      });
    },

    sortData(data) {
      return data.sort(this.compare);
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const bandA = a.region.toUpperCase();
      const bandB = b.region.toUpperCase();

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },
    plotData(data) {
      this.chartdata = {
        //Data to be represented on x-axis
        labels: [...data.map(d => d.region)],
        datasets: [
          {
            //label: "Parking Revenue",
            backgroundColor: "#f87979",
            borderColor: "#f87979",
            pointBackgroundColor: "white",
            borderWidth: 3,
            pointBorderColor: "#249EBF",
            fill: false,
            order: 2,
            //Data to be represented on y-axis
            data: [...data.map(d => Math.round(d.revenue))]
          },
          {
            //label: "Number of Transactions",
            borderColor: "#005cbb",
            pointBackgroundColor: "white",
            borderWidth: 3,
            pointBorderColor: "#249EBF",
            fill: false,
            order: 1,
            type: "line",
            //Data to be represented on y-axis
            data: [...data.map(d => Math.round(d.count))]
          }
        ]
      };

      this.options = {
        tooltips: {
          callbacks: {
            label: function(tooltipItem) {
              let label =
                tooltipItem.datasetIndex === 0
                  ? "Parking Revenue: " + new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 1
                    }).format(tooltipItem.yLabel)
                  : "Transaction Count: " + tooltipItem.yLabel.toLocaleString();
              return label;
            }
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function(value) {
                  return new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0
                  }).format(value);
                }
              },
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true,
                labelString: "Revenue in dollar/Transaction Count"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: "Region"
              }
            }
          ]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      };
      this.componentkey += 1;
      this.loaded = true;
    },

    rescale() {
      this.durationIndex = this.timeIndex + 1;
      this.bindChart();
    }
  },

  computed: {
    timescale() {
      let year = this.startyear;
      return [...Array(this.years).keys()].map(() => --year + 1).sort();
    }
  }
};
</script>